import { createSlice } from "@reduxjs/toolkit";
import {
  sendHybridOTP,
  verifyHybridOTP,
  completeMerchantProfile,
  completeInfluencerProfile,
  signUp,
  login,
  merchantRegister,
  merchantPreference,
  getTotalMerchants,
  sendOTP,
  verifyOTP,
  forgotPassword,
  resetPassword,
  sendLoginOTP,
  verifyLoginOTP,
} from "./AuthThunk";
import { status } from "../../_constants/common";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    registeredUser: {
      status: null,
      data: {},
    },
    loggedInUser: {
      status: null,
      data: {},
    },
    registeredMerchant: {
      status: null,
      data: {},
    },
    merchantPreference: {
      status: null,
      data: {},
    },
    totalMerchants: {
      status: null,
      data: {},
    },
    hybridOtpSent: {
      status: null,
      data: {},
    },
    hybridOtpVerified: {
      status: null,
      data: {},
    },
    completeMerchantProfile: {
      status: null,
      data: {},
    },
    completeInfluencerProfile: {
      status: null,
      data: {},
    },
    // Legacy flow state retained intentionally.
    otpSent: {
      status: null,
      data: {},
    },
    otpVerified: {
      status: null,
      data: {},
    },
    loginOtpSent: {
      status: null,
      data: {},
    },
    loginOtpVerified: {
      status: null,
      data: {},
    },
    forgotPassword: {
      status: null,
      data: {},
    },
    resetPassword: {
      status: null,
      data: {},
    },
  },
  reducers: {
    clearOtpSent: (state) => {
      state.otpSent = { status: null, data: {} };
    },
    clearOtpVerified: (state) => {
      state.otpVerified = { status: null, data: {} };
    },
    clearLoginOtpSent: (state) => {
      state.loginOtpSent = { status: null, data: {} };
    },
    clearLoginOtpVerified: (state) => {
      state.loginOtpVerified = { status: null, data: {} };
    },
    clearHybridOtpSent: (state) => {
      state.hybridOtpSent = { status: null, data: {} };
    },
    clearHybridOtpVerified: (state) => {
      state.hybridOtpVerified = { status: null, data: {} };
    },
    clearCompleteMerchantProfile: (state) => {
      state.completeMerchantProfile = { status: null, data: {} };
    },
    clearCompleteInfluencerProfile: (state) => {
      state.completeInfluencerProfile = { status: null, data: {} };
    },
    logout: (state) => {
      // Reset all auth-related state
      state.loggedInUser = { status: null, data: {} };
      state.hybridOtpSent = { status: null, data: {} };
      state.hybridOtpVerified = { status: null, data: {} };
      state.completeMerchantProfile = { status: null, data: {} };
      state.completeInfluencerProfile = { status: null, data: {} };
      state.otpVerified = { status: null, data: {} };
      state.otpSent = { status: null, data: {} };
      state.loginOtpSent = { status: null, data: {} };
      state.loginOtpVerified = { status: null, data: {} };
      state.registeredUser = { status: null, data: {} };
      state.forgotPassword = { status: null, data: {} };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signUp.pending.toString(), (state, action) => {
        return {
          ...state,
          registeredUser: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(signUp.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          registeredUser: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(signUp.rejected.toString(), (state, action) => {
        return {
          ...state,
          registeredUser: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(login.pending.toString(), (state, action) => {
        return {
          ...state,
          loggedInUser: {
            status: status.IN_PROGRESS,
          },
        };
      })
      .addCase(login.fulfilled.toString(), (state, { payload }) => {
        // console.log("Login fulfilled payload:", payload);
        return {
          ...state,
          loggedInUser: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(login.rejected.toString(), (state, action) => {
        console.log("Login rejected action:", action);
        return {
          ...state,
          loggedInUser: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(merchantRegister.pending.toString(), (state, action) => {
        return {
          ...state,
          registeredMerchant: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(merchantRegister.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          registeredMerchant: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(merchantRegister.rejected.toString(), (state, action) => {
        return {
          ...state,
          registeredMerchant: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(merchantPreference.pending.toString(), (state, action) => {
        return {
          ...state,
          merchantPreference: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(
        merchantPreference.fulfilled.toString(),
        (state, { payload }) => {
          return {
            ...state,
            merchantPreference: {
              status: status.SUCCESS,
              data: payload,
            },
          };
        }
      )
      .addCase(merchantPreference.rejected.toString(), (state, action) => {
        return {
          ...state,
          merchantPreference: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(getTotalMerchants.pending.toString(), (state, action) => {
        return {
          ...state,
          totalMerchants: {
            status: status.IN_PROGRESS,
          },
        };
      })
      .addCase(getTotalMerchants.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          totalMerchants: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(getTotalMerchants.rejected.toString(), (state, action) => {
        return {
          ...state,
          totalMerchants: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(sendHybridOTP.pending.toString(), (state) => {
        return {
          ...state,
          hybridOtpSent: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(sendHybridOTP.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          hybridOtpSent: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(sendHybridOTP.rejected.toString(), (state, action) => {
        return {
          ...state,
          hybridOtpSent: {
            status: status.FAILURE,
            data: action.payload || action.error,
          },
        };
      })

      .addCase(verifyHybridOTP.pending.toString(), (state) => {
        return {
          ...state,
          hybridOtpVerified: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(verifyHybridOTP.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          hybridOtpVerified: {
            status: status.SUCCESS,
            data: payload,
          },
          loggedInUser: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(verifyHybridOTP.rejected.toString(), (state, action) => {
        return {
          ...state,
          hybridOtpVerified: {
            status: status.FAILURE,
            data: action.payload || action.error,
          },
        };
      })

      .addCase(completeMerchantProfile.pending.toString(), (state) => {
        return {
          ...state,
          completeMerchantProfile: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(completeMerchantProfile.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          completeMerchantProfile: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(completeMerchantProfile.rejected.toString(), (state, action) => {
        return {
          ...state,
          completeMerchantProfile: {
            status: status.FAILURE,
            data: action.payload || action.error,
          },
        };
      })

      .addCase(completeInfluencerProfile.pending.toString(), (state) => {
        return {
          ...state,
          completeInfluencerProfile: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(completeInfluencerProfile.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          completeInfluencerProfile: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(completeInfluencerProfile.rejected.toString(), (state, action) => {
        return {
          ...state,
          completeInfluencerProfile: {
            status: status.FAILURE,
            data: action.payload || action.error,
          },
        };
      })

      .addCase(sendOTP.pending.toString(), (state, action) => {
        return {
          ...state,
          otpSent: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(sendOTP.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          otpSent: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(sendOTP.rejected.toString(), (state, action) => {
        return {
          ...state,
          otpSent: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(verifyOTP.pending.toString(), (state, action) => {
        return {
          ...state,
          otpVerified: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(verifyOTP.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          otpVerified: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(verifyOTP.rejected.toString(), (state, action) => {
        return {
          ...state,
          otpVerified: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(forgotPassword.pending.toString(), (state, action) => {
        return {
          ...state,
          forgotPassword: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(forgotPassword.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          forgotPassword: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(forgotPassword.rejected.toString(), (state, action) => {
        return {
          ...state,
          forgotPassword: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(resetPassword.pending.toString(), (state, action) => {
        return {
          ...state,
          resetPassword: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(resetPassword.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          resetPassword: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(resetPassword.rejected.toString(), (state, action) => {
        return {
          ...state,
          resetPassword: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(sendLoginOTP.pending.toString(), (state, action) => {
        return {
          ...state,
          loginOtpSent: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(sendLoginOTP.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          loginOtpSent: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(sendLoginOTP.rejected.toString(), (state, action) => {
        return {
          ...state,
          loginOtpSent: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      })

      .addCase(verifyLoginOTP.pending.toString(), (state, action) => {
        return {
          ...state,
          loginOtpVerified: {
            status: status.IN_PROGRESS,
            data: null,
          },
        };
      })
      .addCase(verifyLoginOTP.fulfilled.toString(), (state, { payload }) => {
        return {
          ...state,
          loginOtpVerified: {
            status: status.SUCCESS,
            data: payload,
          },
          loggedInUser: {
            status: status.SUCCESS,
            data: payload,
          },
        };
      })
      .addCase(verifyLoginOTP.rejected.toString(), (state, action) => {
        return {
          ...state,
          loginOtpVerified: {
            status: status.FAILURE,
            data: action.error,
          },
        };
      });
  },
});

export const {
  clearOtpSent,
  clearOtpVerified,
  clearLoginOtpSent,
  clearLoginOtpVerified,
  clearHybridOtpSent,
  clearHybridOtpVerified,
  clearCompleteMerchantProfile,
  clearCompleteInfluencerProfile,
  logout,
} = authSlice.actions;
export default authSlice.reducer;
